import { Component, Input } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FieldLabelComponent } from '../../../ui/forms/field-label/field-label.component';
import { FieldErrorComponent } from '../../../ui/forms/field-error/field-error.component';

export interface DropdownOption {
	value: string | number;
	label: string;
}

@Component({
	selector: 'app-dropdown-control',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, FieldLabelComponent, FieldErrorComponent],
	templateUrl: './dropdown-control.component.html',
	styleUrls: ['./dropdown-control.component.scss'],
})
export class DropdownControlComponent extends BaseControlComponent {
	@Input('options') public options: DropdownOption[] = [];
	@Input('multiple') public multiple: boolean = false;
}
